module.exports = __webpack_public_path__ + "img/info_banner.c7a5c271.c7a5c271.jpg";